import { createIcon } from '@chakra-ui/react';
import React from 'react';
const EpcIcon = createIcon({
    displayName: 'EpcIcon',
    path: React.createElement("path", { d: "M10 0H28V28H10L0 13L10 0Z", fill: "currentColor" }),
});
export default EpcIcon;
